import React,{Component} from 'react';
import "./style.less"
import {NavBar, Checkbox, List, Toast, ListView, Icon} from "antd-mobile";
import {invoiceOrderList} from "../../service/invoiceService";
import connect from "react-redux/es/connect/connect";
const CheckboxItem = Checkbox.CheckboxItem;
const notInvoice = require('../../common/image/noInvoice.png');
const dataError = require('../../common/image/wrongData.png');
let invoiceId=[];
let pageNum = 1;
let pageSize = 500;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Invoice extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state={
            dataSource,
            isLoading: true,
            notDataLoading:0,
            data:[],
            allCheck:false,
            invoiceId:[],
            invoicePic:0.00,
        }
    }
    componentDidMount() {
        let params={
            "source":6,
            "token":this.props.userInfo.token,
            "data":{
                "type":1,
                "pageSize":pageSize,
                "pageNum":pageNum,
                "invoiceType":1,
                
            }
            
        };
        this.initData(params);

    }
    initData(params){
        Toast.loading("正在加载",0);
        invoiceOrderList(params).then(res => {
            if (res.data.code === '0000') {
                console.log(res);
                Toast.hide();
                if (res.data.data.list.length > 0) {
                    res.data.data.list.map((res)=>{
                        res.checkBox = false;
                        invoiceId.push(res.id);
                        res.invoiceAmountAvailable = parseFloat(res.invoiceAmountAvailable)
                    });
                    // this._setDataSource(res.data.data);
                    this.setState({
                        data: res.data.data.list,
                    });
                }else{
                    this.setState({notDataLoading: 1,});
                }
               
            } else{
                Toast.info(res.data.msg,3) ;
                this.setState({notDataLoading: 2,});
            }
            }).catch(function (error) {
                Toast.hide();
                console.log(error);
            });
    }
    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageNum * pageSize >= data.pageCount) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        let params={
            token:this.props.userInfo.token,
            pageSize:pageSize,
            pageNum:++pageNum,
            invoiceType:1,
        };
        this.initData(params);
    };
    onChange = (val,e,index) => {
        let data = this.state.data;
        let flag = true;
        let id = this.state.invoiceId;
        let pic = this.state.invoicePic;
        let disabled = {}
        data.map((res,i)=>{
            if(res.id == this.state.invoiceId[0]){
                disabled = res
            }
            if(!res.checkBox){
                flag = false
            }
        });
        //改变列表点击的选择状态
        if(e.target.checked == true){
            if((val.isBwy == disabled.isBwy && val.invoiceSign == disabled.invoiceSign) || disabled.isBwy == undefined){
                
                // if(val.isBwy == disabled.isBwy || disabled.isBwy == undefined){
                data[index].checkBox = true;
                id.push(val.id);
                pic+=val.invoiceAmountAvailable;
            }else{
                Toast.info("该订单不能合并开票",3)
            }
        }else if(e.target.checked == false){
            data[index].checkBox = false;
            id.splice(id.findIndex(item => item === val.id), 1)
            pic -= val.invoiceAmountAvailable;
        }
        //如果列表中没有全部选中，那么全选按钮不能未选中状态
        if(flag){
            this.setState({allCheck:true});
        }else{
            this.setState({allCheck:false});
        }
        this.setState({data,invoiceId:id,invoicePic:pic});
    };
    allChange =(e)=>{
        let data = this.state.data;
        let id = [];
        let pic = 0;
        //全选按钮如果选中，列表中所有项，选中，反之全不选
        data.map((res,i)=>{
            if(e.target.checked == true){
                res.checkBox = true;
                id.push(invoiceId[i]);
                pic+=res.invoiceAmountAvailable;
                this.setState({allCheck:true});
            }else if(e.target.checked == false){
                res.checkBox = false;
                this.setState({allCheck:false});
            }
        });
        this.setState({data,invoiceId:id,invoicePic:pic});
    };
    okBtn(){
        if(this.state.invoiceId.length == 0){
            Toast.info("请选择需要申请发票的项");
             return
        }
        let isBwyData = this.state.data.find((item)=>item.id == this.state.invoiceId[0])
        if(isBwyData.isBwy == 0 && this.state.invoiceId.length > 8){
            Toast.info("您选择的开票类型不能超过8条")
            return
        }
        this.props.history.push('/invoiceInfo',{invoiceId:this.state.invoiceId,invoicePic:this.state.invoicePic,isBwy:isBwyData.isBwy,invoiceSign:isBwyData.invoiceSign})
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                <img src={notInvoice} />
                <p>暂无可开发票</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    render(){
        return(
            <div className="invoice">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >发票申请</NavBar>

                <List className="con">
                {this.notData()}
                    {
                        this.state.data.map((i,index) => (
                            <div className="invoiceBox" key={index} >
                                <div className="time">
                                    <span className="orderNo"><span>订单号</span>&nbsp;&nbsp;{i.orderNum}</span>

                                </div>
                                <div className="cityInvoice">
                                    <CheckboxItem key={i.ids} onChange={(e) => this.onChange(i,e,index)} checked={i.checkBox} />

                                    <div className="box">
                                        <div className="timeBox"><i className="icon iconfont iconshijian" /><span>{i.startTime}</span></div>
                                        <div className="endBox">
                                            <i className="icon iconfont icondaixiadanchufadi" style={{color:'#616372'}}/>
                                            <span>{i.startCity}</span> — <span className="endSpan">{i.endCity}</span>
                                            <span className="circleDiv">{i.startBusiness}</span>
                                        </div>
                                    </div>
                                    <div  className="pic"><span className="actualAmount">￥{i.invoiceAmountAvailable}</span></div>

                                </div>
                            </div>
                        ))
                    }
                </List>
                <div  className="allBtn">
                    <div className="button">
                        <List className="allList">
                            <span>￥{this.state.invoicePic.toFixed(2)}</span>
                            {/* <CheckboxItem onChange={(e) => this.allChange(e)} checked={this.state.allCheck}>
                                全选<span>￥{this.state.invoicePic.toFixed(2)}</span>
                            </CheckboxItem> */}
                        </List>
                        <div className="btn"><button onClick={()=> this.okBtn()}>开发票</button></div>
                    </div>

                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/index.js